import { RouterUtil, RouteUtil } from '@us/web/shared/utils';
import { ChangeDetectionStrategy, Component, inject, viewChild } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { IonicModule } from '@ionic/angular';
import { OrderDetailComponent } from '../../components';
import { TranslocoModule } from '@ngneat/transloco';
import { RouteService } from '@us/web/shops/feature';
import { injectParams } from 'ngxtension/inject-params';

@UntilDestroy()
@Component({
    selector: 'us-order-detail-page',
    templateUrl: './order-detail.page.html',
    styleUrls: ['./order-detail.page.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [IonicModule, OrderDetailComponent, TranslocoModule]
})
export class OrderDetailPage {
    protected readonly routeService = inject(RouteService);

    protected readonly orderId = injectParams<string>(params => params[RouterUtil.Cog.OrderId]);
    readonly cmp = viewChild(OrderDetailComponent);
    readonly homePageUrl$ = this.routeService.homePageUrl$;
    readonly RouteUtil = RouteUtil;

    handleRefresh(event: any = null) {
        this.cmp()?.handleRefresh(event);
    }
}
